import React from 'react';
import './About2.css';

const About2 = () => {
  return (
    <section className="about2-section">
      <div className="about2-container">
        <div className="about2-badge">Why We Started Event House</div>
        
        <p className="about2-description">
          In a world of screens and swipes, real connection has become rare.
        </p>
        
        <p className="about2-highlight">
          Event House exists to bring people back to meaningful, offline experiences.
        </p>
        
        <p className="about2-description">
          We create thoughtfully curated spaces where conversations flow naturally — without pressure, labels, or expectations.
          With Mulaqaat, our signature singles mixer, we focus on quality over quantity, presence over profiles, and experiences that feel real.
        </p>
        
        <p className="about2-quote">
          Some connections aren't meant to be matched. They're meant to be met.
        </p>
      </div>
    </section>
  );
};

export default About2;
